import { isNil, omit } from 'lodash';
import moment from 'moment';
import { env } from '~/commons/config';

export const arrDefaults = {
  extra: {
    walved: false,
    serviceType: '',
    service: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    status: '',
    deliServ: '',
    deliTrackNo: '',
    amount: 0,
    remarks: '',
    _id: '',
  },
  paymentMethod: {
    payment: '',
    card: '',
    bank: '',
    cheque: '',
    amount: 0,
    receiptNumber: '',
  },
  extraItems: {
    description: '',
    price: 0,
  },
};

export const formDefaults = {
  refCode: '',
  customer: { erpId: '' },
  status: '',
  items: [],
  tfyItems: [],
  restockItems: [],
  extra: [arrDefaults.extra],
  extraItems: [arrDefaults.extraItems],
  currency: '',
  discount: {
    percent: '',
    fixed: '',
  },
  remarks: '',
  billingAddress: {
    erpId: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    city: '',
    state: '',
    province: '',
    county: '',
    country: '',
    postCode: '',
    countryCode: '',
    remarks: '',
  },
  shippingAddress: {
    erpId: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    city: '',
    state: '',
    province: '',
    county: '',
    country: '',
    postCode: '',
    countryCode: '',
    remarks: '',
  },
  orgId: '',
  issuedBy: '',
  paymentRefNo: '',
  projectNo: '',
  isTradePrice: false,
};

export const countryObj = env.countryCode.reduce(
  (acc, cur) => ({ ...acc, [cur.code]: cur.short }),
  {},
);

export const extraSubmit = (extra, notFixedQty) => extra.map((x = {}) => {
  ['start', 'end'].forEach((k) => {
    const date = x[`${k}Date`];
    const time = x[`${k}Time`];
    if (date) {
      x[`${k}At`] = moment(date).startOf('days').toDate();
    }
    if (date && time) {
      x[`${k}At`] = moment(
        `${date} ${time}`,
        'YYYY-MM-DD HH:mm',
      ).toDate();
    }
  });

  if (!x.service) delete x.service;
  x.uom = notFixedQty?.[x?.service]?.uom || 'EA';
  x.qty = x.uom === 'EA' ? 1 : x.qty;
  return x;
});

export const removeEmpty = (data, fields) => {
  fields.forEach((x) => {
    data[x] = (data[x] || [])
      .filter(
        (y) => !Object.entries(arrDefaults[x]).every(
          ([key, val]) => String(y[key]) === String(val),
        ),
      )
      .map((y) => omit(y, ['_id']));
  });
  return data;
};

export const extraDateTimeMap = (extra) => (extra || []).map((v) => {
  ['start', 'end'].forEach((k) => {
    if (isNil(v[`${k}At`])) {
      v[`${k}Date`] = '';
      v[`${k}Time`] = '';
    } else {
      v[`${k}Date`] = moment(v[`${k}At`]).format(
        'YYYY-MM-DD',
      );
      v[`${k}Time`] = moment(v[`${k}At`]).format('HH:mm');
    }
  });
  return v;
});
